import * as React from "react"
import type { IconProps } from "../types"

const ChevronRightMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 16 16"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={2}
          d="M6.6665 10.6667L9.33317 8.00004L6.6665 5.33337"
        />
      </svg>
    )
  }
)
ChevronRightMini.displayName = "ChevronRightMini"

export default ChevronRightMini
